import React from 'react';
import '../../styles/mainMenu.css';
import Slider from '../common/Slider';
import GallerySection from '../diagrams/GallerySection';
import { useLanguage } from "../common/LanguageContext";

function MainMenu({ isMenuOpen }) {
  const { translations } = useLanguage();

  return (
    <main className={`main-menu ${isMenuOpen ? 'menu-open' : ''}`}>
      {/* Секция заголовка с видео */}
      <section className="main-video-section">
        <video className="main-video" src="/mainVideo.mp4" autoPlay muted />
      </section>
      {/* Описание ниже */}
      <div className="slider-description">
        <div className="description-item">
          <div className="description-circle"></div>
          <span className="description-text">
            {translations.mainPage.img1.desc1}
          </span>
        </div>
        <div className="description-item">
          <div className="description-circle"></div>
          <span className="description-text">
            {translations.mainPage.img1.desc2}
          </span>
        </div>
        <div className="description-item">
          <div className="description-circle"></div>
          <span className="description-text">
            {translations.mainPage.img1.desc3}
          </span>
        </div>
      </div>
      {/* Галерея с описаниями */}
      <GallerySection
        image="/exclusive.png"
        title={translations.mainPage.img2.title}
        description={translations.mainPage.img2.desc}
        buttons={[
          { text: translations.mainPage.buttonsText1, path: '/gallery' },
          { text: translations.mainPage.buttonsText2, path: '/constructor' },
        ]}
      />
      <GallerySection
        image="/individual.png"
        title={translations.mainPage.img3.title}
        description={translations.mainPage.img3.desc}
        buttons={[
          { text: translations.mainPage.buttonsText1, path: '/gallery' },
          { text: translations.mainPage.buttonsText2, path: '/constructor' },
        ]}
      />
      <GallerySection
        image="/technology.png"
        title={translations.mainPage.img4.title}
        description={translations.mainPage.img4.desc}
        buttons={[
          { text: translations.mainPage.buttonsText1, path: '/gallery' },
          { text: translations.mainPage.buttonsText2, path: '/constructor' },
        ]}
      />
      <section className="main-hero">
        <Slider
          title={translations.mainPage.img5.title}
          slidesData={['/strongCarcase.png', '/frame.png']}
        />
      </section>
      <div className='gallery-description-last'>
        {translations.mainPage.img5.p1}<br />
        {translations.mainPage.img5.p2}<br />
        {translations.mainPage.img5.p3}
      </div>
    </main>
  );
}

export default MainMenu;
